import React from "react";
import ililce from "../../helpers/ililce";

class GuestAddressForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      first_name: "",
      last_name: "",
      city: "",
      town: "",
      phone: "",
      address: "",
      // Fatura bilgileri
      sameAsDelivery: true,
      corporateInvoice: false,
      invoice_first_name: "",
      invoice_last_name: "",
      invoice_company_name: "",
      invoice_tax_number: "",
      invoice_tax_office: "",
      invoice_address: "",
      invoice_city: "",
      invoice_town: "",
      errors: {},
    };
  }

  componentDidMount() {
    // Eğer props'tan initial data gelmişse state'i güncelle
    if (this.props.initialData) {
      this.setState({
        ...this.state,
        ...this.props.initialData,
        errors: {}, // Hataları sıfırla
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Props değiştiğinde (düzenle butonuna basıldığında) state'i güncelle
    if (
      this.props.initialData &&
      this.props.initialData !== prevProps.initialData
    ) {
      this.setState({
        ...this.state,
        ...this.props.initialData,
        errors: {},
      });
    }
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    // Telefon için özel işlem - sadece rakamları al
    if (name === "phone" && type !== "checkbox") {
      newValue = value.replace(/\D/g, "");
      // Maximum 10 hane
      if (newValue.length > 10) {
        newValue = newValue.substring(0, 10);
      }
    }

    // Vergi numarası için özel işlem - sadece rakamları al
    if (name === "invoice_tax_number" && type !== "checkbox") {
      newValue = value.replace(/\D/g, "");
      // Maximum 11 hane (VKN: 10, TCKN: 11)
      if (newValue.length > 11) {
        newValue = newValue.substring(0, 11);
      }
    }

    this.setState(
      {
        [name]: newValue,
      },
      () => {
        // Parent component'e güncellemeyi bildir
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      }
    );
  };

  handleCityChange = (e) => {
    this.setState(
      {
        city: e.target.value,
        town: "", // Şehir değişince ilçeyi sıfırla
      },
      () => {
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      }
    );
  };

  validate = () => {
    const errors = {};
    const {
      email,
      first_name,
      last_name,
      city,
      town,
      phone,
      address,
      sameAsDelivery,
      corporateInvoice,
      invoice_first_name,
      invoice_last_name,
      invoice_company_name,
      invoice_tax_number,
      invoice_tax_office,
      invoice_address,
      invoice_city,
      invoice_town,
    } = this.state;

    // İletişim ve teslimat bilgileri
    if (!email || !email.includes("@"))
      errors.email = "Geçerli bir e-posta adresi giriniz";
    if (!first_name || first_name.trim() === "")
      errors.first_name = "Ad zorunludur";
    if (!last_name || last_name.trim() === "")
      errors.last_name = "Soyad zorunludur";
    if (!city) errors.city = "Şehir seçiniz";
    if (!town) errors.town = "İlçe seçiniz";

    // Telefon validasyonu - 10 haneli, başında sıfır yok
    if (!phone) {
      errors.phone = "Telefon numarası giriniz";
    } else if (phone.length !== 10) {
      errors.phone = "Telefon numarası 10 haneli olmalıdır";
    } else if (phone.charAt(0) === "0") {
      errors.phone = "Telefon numarası 0 ile başlamamalıdır";
    }

    if (!address || address.trim() === "") errors.address = "Adres giriniz";

    // Kurumsal fatura kontrolleri
    if (corporateInvoice) {
      if (!invoice_company_name || invoice_company_name.trim() === "")
        errors.invoice_company_name = "Firma adı giriniz";
      if (!invoice_tax_number || invoice_tax_number.trim() === "")
        errors.invoice_tax_number = "Vergi numarası giriniz";
      else if (!/^\d+$/.test(invoice_tax_number.trim()))
        errors.invoice_tax_number = "Vergi numarası sadece rakamlardan oluşmalıdır";
      else if (invoice_tax_number.trim().length < 10)
        errors.invoice_tax_number = "Vergi numarası en az 10 haneli olmalıdır";
      if (!invoice_tax_office || invoice_tax_office.trim() === "")
        errors.invoice_tax_office = "Vergi dairesi giriniz";
    }

    // Fatura adresi farklı ise kontroller
    if (!sameAsDelivery) {
      if (!invoice_first_name || invoice_first_name.trim() === "")
        errors.invoice_first_name = "Fatura adı giriniz";
      if (!invoice_last_name || invoice_last_name.trim() === "")
        errors.invoice_last_name = "Fatura soyadı giriniz";
      if (!invoice_city) errors.invoice_city = "Fatura şehri seçiniz";
      if (!invoice_town) errors.invoice_town = "Fatura ilçesi seçiniz";
      if (!invoice_address || invoice_address.trim() === "")
        errors.invoice_address = "Fatura adresi giriniz";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  getData = () => {
    if (this.validate()) {
      return this.state;
    }
    return null;
  };

  render() {
    const {
      email,
      first_name,
      last_name,
      city,
      town,
      phone,
      address,
      sameAsDelivery,
      corporateInvoice,
      invoice_first_name,
      invoice_last_name,
      invoice_company_name,
      invoice_tax_number,
      invoice_tax_office,
      invoice_address,
      invoice_city,
      invoice_town,
      errors,
    } = this.state;

    const cities = ililce.map((item) => item.il);
    const towns =
      city && ililce.find((item) => item.il === city)
        ? ililce.find((item) => item.il === city).ilceleri
        : [];

    return (
      <div>
        {/* İletişim Bilgileri */}
        <div style={styles.sectionTitle}>İletişim Bilgileri</div>
        <div className="form-group">
          <label style={styles.label}>
            E-Posta <span style={styles.required}>*</span>
          </label>
          <input
            type="email"
            name="email"
            value={email}
            onChange={this.handleChange}
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            placeholder="ornek@email.com"
          />
          {errors.email && (
            <div className="invalid-feedback">{errors.email}</div>
          )}
          <small className="form-text text-muted">
            <i className="fa fa-info-circle"></i> Sipariş takibi için e-posta
            adresinize bilgi gönderilecektir
          </small>
        </div>

        <hr style={styles.divider} />

        {/* Teslimat Adresi */}
        <h6 style={styles.sectionTitle}>Teslimat Adresi</h6>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                Ad <span style={styles.required}>*</span>
              </label>
              <input
                type="text"
                name="first_name"
                value={first_name}
                onChange={this.handleChange}
                className={`form-control ${
                  errors.first_name ? "is-invalid" : ""
                }`}
                placeholder="Adınız"
              />
              {errors.first_name && (
                <div className="invalid-feedback">{errors.first_name}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                Soyad <span style={styles.required}>*</span>
              </label>
              <input
                type="text"
                name="last_name"
                value={last_name}
                onChange={this.handleChange}
                className={`form-control ${
                  errors.last_name ? "is-invalid" : ""
                }`}
                placeholder="Soyadınız"
              />
              {errors.last_name && (
                <div className="invalid-feedback">{errors.last_name}</div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                Şehir <span style={styles.required}>*</span>
              </label>
              <select
                name="city"
                value={city}
                onChange={this.handleCityChange}
                className={`form-control ${errors.city ? "is-invalid" : ""}`}
              >
                <option value="">Şehir Seçiniz</option>
                {cities.map((c, i) => (
                  <option key={i} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              {errors.city && (
                <div className="invalid-feedback">{errors.city}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                İlçe <span style={styles.required}>*</span>
              </label>
              <select
                name="town"
                value={town}
                onChange={this.handleChange}
                className={`form-control ${errors.town ? "is-invalid" : ""}`}
                disabled={!city}
              >
                <option value="">İlçe Seçiniz</option>
                {towns.map((t, i) => (
                  <option key={i} value={t}>
                    {t}
                  </option>
                ))}
              </select>
              {errors.town && (
                <div className="invalid-feedback">{errors.town}</div>
              )}
            </div>
          </div>
        </div>

        <div className="form-group">
          <label style={styles.label}>
            Telefon <span style={styles.required}>*</span>
          </label>
          <input
            type="tel"
            name="phone"
            value={phone}
            onChange={this.handleChange}
            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
            placeholder="5XX XXX XX XX (10 haneli, başında sıfır olmadan)"
          />
          {errors.phone && (
            <div className="invalid-feedback">{errors.phone}</div>
          )}
          <small className="form-text text-muted">
            <i className="fa fa-info-circle"></i> Telefon numaranızı başında
            sıfır olmadan 10 haneli olarak giriniz (örn: 5321234567)
          </small>
        </div>

        <div className="form-group">
          <label style={styles.label}>
            Adres <span style={styles.required}>*</span>
          </label>
          <textarea
            name="address"
            value={address}
            onChange={this.handleChange}
            className={`form-control ${errors.address ? "is-invalid" : ""}`}
            rows="3"
            placeholder="Mahalle, sokak, bina no, daire no vb."
          ></textarea>
          {errors.address && (
            <div className="invalid-feedback">{errors.address}</div>
          )}
        </div>

        <hr style={styles.divider} />

        {/* Fatura Bilgileri */}

        {/* Fatura adresim, teslimat adresim ile aynı olsun */}
        <div className="form-group">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="sameAsDelivery"
              name="sameAsDelivery"
              checked={sameAsDelivery}
              onChange={this.handleChange}
            />
            <label className="custom-control-label" htmlFor="sameAsDelivery">
              Fatura adresim, teslimat adresim ile aynı olsun
            </label>
          </div>
        </div>

        {/* Fatura Adresi Farklı ise */}
        {!sameAsDelivery && (
          <div style={{ marginTop: "20px" }}>
            <h6 style={styles.sectionTitle}>Fatura Adresi</h6>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    Ad <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="invoice_first_name"
                    value={invoice_first_name}
                    onChange={this.handleChange}
                    className={`form-control ${
                      errors.invoice_first_name ? "is-invalid" : ""
                    }`}
                    placeholder="Fatura İçin Ad"
                  />
                  {errors.invoice_first_name && (
                    <div className="invalid-feedback">
                      {errors.invoice_first_name}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    Soyad <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="invoice_last_name"
                    value={invoice_last_name}
                    onChange={this.handleChange}
                    className={`form-control ${
                      errors.invoice_last_name ? "is-invalid" : ""
                    }`}
                    placeholder="Fatura İçin Soyad"
                  />
                  {errors.invoice_last_name && (
                    <div className="invalid-feedback">
                      {errors.invoice_last_name}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    İl <span style={styles.required}>*</span>
                  </label>
                  <select
                    name="invoice_city"
                    value={invoice_city}
                    onChange={this.handleChange}
                    className={`form-control ${
                      errors.invoice_city ? "is-invalid" : ""
                    }`}
                  >
                    <option value="">Şehir Seçiniz</option>
                    {cities.map((c, i) => (
                      <option key={i} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                  {errors.invoice_city && (
                    <div className="invalid-feedback">
                      {errors.invoice_city}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    İlçe <span style={styles.required}>*</span>
                  </label>
                  <select
                    name="invoice_town"
                    value={invoice_town}
                    onChange={this.handleChange}
                    className={`form-control ${
                      errors.invoice_town ? "is-invalid" : ""
                    }`}
                    disabled={!invoice_city}
                  >
                    <option value="">İlçe Seçiniz</option>
                    {invoice_city &&
                      ililce.find((item) => item.il === invoice_city) &&
                      ililce
                        .find((item) => item.il === invoice_city)
                        .ilceleri.map((t, i) => (
                          <option key={i} value={t}>
                            {t}
                          </option>
                        ))}
                  </select>
                  {errors.invoice_town && (
                    <div className="invalid-feedback">
                      {errors.invoice_town}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="form-group">
              <label style={styles.label}>
                Adres <span style={styles.required}>*</span>
              </label>
              <textarea
                name="invoice_address"
                value={invoice_address}
                onChange={this.handleChange}
                className={`form-control ${
                  errors.invoice_address ? "is-invalid" : ""
                }`}
                rows="3"
                placeholder="Fatura adresi detayı"
              ></textarea>
              {errors.invoice_address && (
                <div className="invalid-feedback">{errors.invoice_address}</div>
              )}
            </div>
          </div>
        )}

        {/* Kurumsal Fatura */}
        <div className="form-group">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="corporateInvoice"
              name="corporateInvoice"
              checked={corporateInvoice}
              onChange={this.handleChange}
            />
            <label className="custom-control-label" htmlFor="corporateInvoice">
              Kurumsal Fatura Bilgisi Girmek İstiyorum
            </label>
          </div>
        </div>

        {/* Kurumsal Fatura Formları */}
        {corporateInvoice && (
          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <div className="form-group">
              <label style={styles.label}>
                Firma Adı <span style={styles.required}>*</span>
              </label>
              <input
                type="text"
                name="invoice_company_name"
                value={invoice_company_name}
                onChange={this.handleChange}
                className={`form-control ${
                  errors.invoice_company_name ? "is-invalid" : ""
                }`}
                placeholder="Firma adı"
              />
              {errors.invoice_company_name && (
                <div className="invalid-feedback">
                  {errors.invoice_company_name}
                </div>
              )}
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    Vergi Numarası <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="invoice_tax_number"
                    value={invoice_tax_number}
                    onChange={this.handleChange}
                    className={`form-control ${
                      errors.invoice_tax_number ? "is-invalid" : ""
                    }`}
                    placeholder="Örn: 8790032867 (sadece rakam)"
                  />
                  {errors.invoice_tax_number && (
                    <div className="invalid-feedback">
                      {errors.invoice_tax_number}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    Vergi Dairesi <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="invoice_tax_office"
                    value={invoice_tax_office}
                    onChange={this.handleChange}
                    className={`form-control ${
                      errors.invoice_tax_office ? "is-invalid" : ""
                    }`}
                    placeholder="Vergi dairesi"
                  />
                  {errors.invoice_tax_office && (
                    <div className="invalid-feedback">
                      {errors.invoice_tax_office}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  sectionTitle: {
    // fontSize: '18px',
    // fontWeight: '600',
    // color: '#272727',
    // marginBottom: '18px',
    // letterSpacing: '0.2px'
    paddingBottom: "16px",
    color: "#272727",
    flex: "1 1 auto",
    fontSize: "20px",
    lineHeight: "32px",
    letterSpacing: "normal",
    fontWeight: "normal",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#4c566a",
    marginBottom: "6px",
  },
  required: {
    color: "#dc3545",
  },
  divider: {
    margin: "28px 0",
    border: 0,
    borderTop: "1px solid #e6eaf2",
  },
};

export default GuestAddressForm;



// WEBPACK FOOTER //
// ./src/components/AddressStep/GuestAddressForm.js